// @flow

import { message } from 'antd';
import { moveItem } from '../../../HttpRequests/files';
import handleException from '../../../Core/Helpers/handleException';
import fetchDirectory from '../Services/fetchDirectory';
import fetchRootDirectories from '../Services/fetchRootDirectories';

export default (sourcePath: string, sourceType: string, destinationPath: string) => async (dispatch: Function) => {
  
  console.log('onDragDropItem called:', { sourcePath, sourceType, destinationPath });
  
  try {
    
    const data = {
      source_path: sourcePath,
      destination_path: destinationPath,
      item_type: sourceType
    };

    console.log('Calling moveItem API with:', data);
    await moveItem({ data });

    message.success(`${sourceType === 'file' ? 'File' : 'Folder'} moved successfully`);

    // Refresh the current directory to show the updated file list
    dispatch(fetchDirectory());
    
    // Refresh the directory tree to show the updated folder structure
    dispatch(fetchRootDirectories());

  } catch (error) {

    if (error.response && error.response.status === 409) {
      message.error('An item with this name already exists in the destination folder');
    } else {
      handleException(error);
    }

  }

}
